import React, { Component } from 'react';
import classnames from 'classnames';
import styles from './styles.module.css';

import SearchIcon from '../../icons/Search';

export default class PillButton extends Component {
  onClick = event => {
    if (this.props.preventDefault) {
      event.preventDefault();
    }

    this.props.onClick(event);
  };

  render() {
    const {
      tag = 'button',
      text,
      onClick,
      small,
      theme,
      htmlFor,
      disabled,
      type,
      to,
      href,
      id,
    } = this.props;

    return React.createElement(
      tag,
      {
        className: classnames(
          styles.container,
          { [styles.small]: small },
          theme && styles[`theme-${theme}`],
          this.props.className
        ),
        to,
        type,
        onClick: onClick ? this.onClick : null,
        href,
        target: href !== undefined ? '_blank' : undefined,
        rel: href !== undefined ? 'nofollow' : undefined,
        htmlFor,
        disabled,
        id,
      },
      <span>{text}</span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pill-button/index.js